import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-180fa878")

_pushScopeId("data-v-180fa878")
const _hoisted_1 = { class: "onetrip-page__content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "infoMsg" }, "Выберете услугу", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
})